import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import type { Size } from '@adornis/html-based-buildify/db/enums.js';
import { validate } from '@adornis/validation/decorators';
import { nonOptional } from '@adornis/validation/functions/nonOptional';
import type { IMedia } from './IMedia';

@Entity()
export class BundleFileMeta extends AdornisEntity {
  static override _class = 'BundleFileMeta';

  @validate(nonOptional())
  @Field(type => String)
  fileReferenceID!: string;

  @validate(nonOptional())
  @Field(type => String)
  size!: Size;
}
@Entity()
export class LASFile extends AdornisFile implements IMedia {
  static override _class = 'LASFile';

  constructor(data: PartialEntityData<LASFile>) {
    super(data);
  }

  @Field(type => String)
  altTag!: Maybe<string>;

  @Field(type => BundleFileMeta)
  bundleMeta?: Maybe<BundleFileMeta>;

  @Field(type => String)
  downloadName: Maybe<string>;

  @Field(type => String)
  parentFolderID?: Maybe<string>;

  @Field(type => Date)
  updatedAt?: Maybe<Date>;
}
